export const trimBreadcrumbs = (text?: string) => {
  if (!text) return text
  if (text.length > 40) return `${text.substring(0, 38)}…`
  return text
}
